module.exports = __webpack_public_path__ + "static/logos-presenca-d7d874c964c73ceb9722dee9ecbab6a3.jpg";